import { BankProduct } from '@modules/banks/api/types';
import { create } from 'zustand';

type ProposalCreationStore = {
  bankProducts: BankProduct[];
  setBankProducts: (bankProducts: ProposalCreationStore['bankProducts']) => void;
};

export const useProposalCreationStore = create<ProposalCreationStore>((set) => ({
  bankProducts: [],
  setBankProducts: (bankProducts) => set(() => ({ bankProducts })),
}));
